import { memo, useLayoutEffect } from "react";
import type { TeachingSessionAssignment } from "@/lib/api/sessionPortal";
import { ReviewWork, type ReviewWorkState } from "../review/ReviewWork";
import type { Report } from "./use-session-review-boxes";

export function ReportBoxes({ id, boxes, onRowOpenChange, onReport }: Report & { id: string; onReport: (id: string, report: Report) => void }) {
  useLayoutEffect(() => onReport(id, { boxes, onRowOpenChange }));
  return null;
}

/**
 * Hosts one piece of work's Review (A3's `ReviewWork`) for the session's
 * Bento: it holds that work's reads, drafts and results, and reports its
 * boxes up. It draws nothing itself. Memoised, so the report it sends never
 * draws it again.
 */
export const ReviewHost = memo(function ReviewHost({ work, timezone, termOpen, roll, ranked, quietOpen, linkKey, onState, onReport }: {
  work: TeachingSessionAssignment;
  timezone: string;
  termOpen: boolean;
  roll: Map<string, string | null> | null;
  ranked: boolean;
  quietOpen: boolean;
  linkKey: number;
  onState: (id: string, state: ReviewWorkState) => void;
  onReport: (id: string, report: Report) => void;
}) {
  return (
    <ReviewWork work={work} timezone={timezone} termOpen={termOpen} roll={roll} ranked={ranked} quietOpen={quietOpen} linkKey={linkKey} onState={onState}
      renderBoxes={(boxes, onRowOpenChange) => <ReportBoxes id={work.id} boxes={boxes} onRowOpenChange={onRowOpenChange} onReport={onReport} />} />
  );
});
